
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import { getNews } from "../../app/api";
import { useNavigate } from "react-router-dom";



const HTMLTextView = ({ htmlContent }: any) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};


const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 940,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};


const NewsSlider = ({ dark = false }: { dark?: boolean }) => {
    const { t } = useTranslation();
    const [Data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const q = {
            offset: "0",
            limit: "8",
            }
            const params = new URLSearchParams(q);

            getNews(params).then((res) => {
                if(res) {
                    setData(res.data.results);
                }
            });
        } catch(err) {
        }
    }, []);

    const NewsCard = ({ post }: { post: any }) => (
        <div
            onClick={() => navigate(`/news/${post.id}`)}
            className="cursor-pointer group"
        >
            <div className="relative w-full overflow-hidden rounded-sm bg-neutral-100 mb-4">
                <img
                    loading="lazy"
                    src={post.thumb}
                    alt={post.title}
                    className="aspect-[16/10] w-full object-cover group-hover:scale-[1.02] transition-transform duration-500 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
            <div>
                <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-bold text-primary-600 uppercase tracking-wide">
                        {post.type}
                    </span>
                </div>
                <h3 className={`text-base font-bold leading-snug mb-2 line-clamp-2 transition-colors ${dark ? 'text-white group-hover:text-primary-300' : 'text-neutral-900 group-hover:text-primary-600'}`}>
                    {post.title}
                </h3>
                <div className="line-clamp-2 text-sm leading-relaxed text-neutral-400">
                    <HTMLTextView htmlContent={post.content} />
                </div>
                <div className="mt-2 text-xs text-primary-500">
                    {t('news.nairamdal')}
                </div>
            </div>
        </div>
    );

    return (
        <div className="py-16 sm:py-20">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mb-10">
                    <h2 className={`text-2xl font-extrabold ${dark ? 'text-white' : 'text-neutral-900'}`}>
                        {t('news.newsTitle')}
                    </h2>
                </div>
                <div>
                    <div>
                        {Data.length <= 3 ?
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                                {Data.map((post: any) => (
                                    <NewsCard key={post.id} post={post} />
                                ))}
                            </div> :
                            <Slider {...settings}>
                                {Data.map((post: any) => (
                                    <div key={post.id} className="px-3">
                                        <NewsCard post={post} />
                                    </div>
                                ))}
                            </Slider>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsSlider;
